export const DATE_FORMAT = 'YYYY-MM-DD'
export const MAIN_COLOR_QRM = '#FF8F00'
export const MAIN_COLOR_CC = '#FF2724'
export const MOMENT_FORMAT = 'YYYY/MM/DD'
export const MOMENT_FORMAT_TIME = 'HH:mm'
